import { PropsWithChildren } from 'react';
import cn from 'classnames';
import { useOfferPageContext } from 'pages/offer/context';
import dzenIcon from '../icons/dzen.svg';
import habrIcon from '../icons/habr.svg';
import tgIcon from '../icons/tg.svg';
import vkIcon from '../icons/vk.svg';
import x5Icon from '../icons/x5.svg';
import styles from './icons-block.module.scss';
import { Spacing, SpacingSize } from './spacing';

export type IconsBlockProps = PropsWithChildren & {
  className?: string;
  classNameIconHabr?: string;
};

/**
 * IconsBlock
 * @param className
 * @param classNameIconHabr
 */
export const IconsBlock = ({ className, classNameIconHabr }: IconsBlockProps) => {
  const {
    userData: {
      businessUnit: { dzen, habr, newx5, telegram, vk },
    },
  } = useOfferPageContext();

  return (
    <Spacing className={cn(styles.iconsBlock, className)} size={SpacingSize.small}>
      {newx5 && (
        <a className={styles.icon} target="_blank" href={newx5} rel="noreferrer">
          <img src={x5Icon} />
        </a>
      )}

      {dzen && (
        <a className={styles.icon} target="_blank" href={dzen} rel="noreferrer">
          <img src={dzenIcon} />
        </a>
      )}

      {vk && (
        <a className={styles.icon} target="_blank" href={vk} rel="noreferrer">
          <img src={vkIcon} />
        </a>
      )}

      {telegram && (
        <a className={styles.icon} target="_blank" href={telegram} rel="noreferrer">
          <img src={tgIcon} />
        </a>
      )}

      {habr && (
        <a className={cn(styles.icon, styles.iconHabr, classNameIconHabr)} target="_blank" href={habr} rel="noreferrer">
          <img src={habrIcon} />
        </a>
      )}
    </Spacing>
  );
};
